import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import './Home.css';
import './SearchByLocation.css';
import residentialPlot from '../assets/images/residential-plots.jpg';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { FaShieldAlt, FaHome, FaUserTie, FaBalanceScale, FaChartLine } from 'react-icons/fa';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import bannerImage from '../assets/images/HomePageBanner.webp';

import AG from '../assets/images/Alekhya Infraa Developers.png';
import AS from '../assets/images/Ananthaa Spaces.png';
import BG from '../assets/images/Bhashyam Developers.png';
import MID from '../assets/images/Mahathi Infra Developers.png';
import RV from '../assets/images/RealVision.png';
import SI from '../assets/images/Silpa Infratech.png';
import TMR from '../assets/images/TMR Group.png';
import AreaListings from './AreaListings';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import dummy from '../assets/images/dummy.png'
import bannContact from '../assets/images/backContact.jpg'


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});


const Home = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [category, setCategory] = useState('');
  const [location, setLocation] = useState('');
  const navigate = useNavigate();

  const hyderabadCoords = [17.385044, 78.486671];
  // Sample data for dropdowns
  const categories = [
    'Residential Plots',
    'Commercial Plots',
    'Agricultural Land',
    'Industrial Plots'
  ];

  const locations = [
    'Miyapur',
    'Madhapur',
    'Hi-Tech City',
    'Gachibowli',
  ];

  const sliderRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      quote: "Working with this company was a game-changer for our industrial operations. Their expertise and attention to detail are unmatched.",
      author: "Michael Johnson",
      position: "Operations Manager, SteelTech Inc.",
      rating: 5,
      image: dummy
    },
    {
      id: 2,
      quote: "The team delivered exceptional results on our factory automation project. Their technical knowledge and professionalism were impressive.",
      author: "Sarah Williams",
      position: "CEO, AutoManufacturing Co.",
      rating: 5,
      image: dummy
    },
    {
      id: 3,
      quote: "We've partnered with them for multiple projects and each time they exceed our expectations. Truly reliable industrial partners.",
      author: "David Chen",
      position: "Director, Industrial Solutions Ltd.",
      rating: 4,
      image: dummy
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!location) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Selection',
        text: 'Please select location',
        confirmButtonText: 'OK',
        customClass: {
          title: 'swal-small-title',
          popup: 'swal-small-popup',
          htmlContainer: 'swal-small-text'
        }
      });
    }
    else if (!category) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Selection',
        text: 'Please select category',
        confirmButtonText: 'OK',
        customClass: {
          title: 'swal-small-title',
          popup: 'swal-small-popup',
          htmlContainer: 'swal-small-text'
        }
      });
    }
    else if (location) {
      navigate(`/${location}/${category}`);
    }

  };

  const benefits = [
    {
      icon: <FaShieldAlt size={30} />,
      title: "Legal Due Diligence",
      description: "Comprehensive legal verification of all property documents"
    },
    {
      icon: <FaHome size={30} />,
      title: "Free Site Visit",
      description: "Home pick and drop service for property visits"
    },
    {
      icon: <FaUserTie size={30} />,
      title: "Verified by Experts",
      description: "All properties verified by Ex-Govt Officers"
    },
    {
      icon: <FaBalanceScale size={30} />,
      title: "1-Year Legal Support",
      description: "Free legal support for one year after purchase"
    },
    {
      icon: <FaChartLine size={30} />,
      title: "AI-Powered Insights",
      description: "Advanced area analysis with artificial intelligence"
    }
  ];


  return (
    <>
      {/* Properties Area */}
      <div className="mainProperties propertyBg pt-60  " id="properties">
        {/* <div className="dashboard-map-frame">
          <MapContainer
            center={hyderabadCoords}
            zoom={9}
            style={{ height: "75vh", width: "100%" }} // full frame
          >
             <TileLayer
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

             <Marker position={hyderabadCoords}>
              <Popup>Hyderabad, Telangana, India</Popup>
            </Marker>
          </MapContainer>
        </div> */}
        <div className=''>
          <div
            className="banner-section"
            style={{ backgroundImage: `url(${bannerImage})` }}
          >
            <div className="banner-overlay"></div>
            <div className="banner-content">
              <h1>Invest Smart. Stay Protected. </h1>
              <h1> Verified Plots by Legal Experts. </h1>
              <div className="breadcrumb-text">
                <div className="header-btn d-none d-lg-block mt-5">
                  <Link to="/listings" className="tp-btn contactBtn">
                    Explore Verified Listings
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Container fluid className="home-container">
          <Row className="mb-60">
            <Col xs={12}>
              <div className="sectionIntro text-center">
                <h5>OUR OFFERINGS</h5>
                <h2 className="sectionTitle textWhite lightTitle">
                  Premium Plots in<br />
                  Prime Locations.
                </h2>
              </div>
            </Col>
          </Row> 
        </Container> */}
      </div>

      {/* <Container style={{ padding: '20px', marginTop: '10px' }}>
        <Row className="justify-content-center dropdownSection">
          <Col lg={10}>
            <div className="property-search-box">
              <Form onSubmit={handleSearch}>
                <Row className="align-items-center">
                  <Col md={3} className="mb-3 mb-md-0">
                    <Form.Group controlId="searchTerm">
                       <Form.Control
                        type="text"
                        placeholder="What are you looking for?"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3 mb-md-0">
                    <Form.Group controlId="location">
                       <Form.Select
                        value={location}
                        className="custom-category-select"
                        onChange={(e) => setLocation(e.target.value)}
                      >
                        <option value="" disabled>Select Locations</option>
                        {locations.map((loc, index) => (
                          <option key={index} value={loc}>{loc}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3 mb-md-0">
                    <Form.Group controlId="category">
                      <Form.Select
                        id="category"
                        className="custom-category-select"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="" disabled>Select Categories</option>
                        {categories.map((cat, index) => (
                          <option key={index} value={cat}>{cat}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                  </Col>



                  <Col md={1}>
                    <button type="submit" className="search-btn searchButton" >
                      Search
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container> */}
      <Container>
        <div className="search-container">
          <div className="search-header">Property Search</div>
          <Form onSubmit={handleSearch} className="search-form">
            <Row className="align-items-center w-100">
              {/* Search Input */}
              <Col md={4} className="search-field">
                <Form.Group controlId="searchTerm">
                  <Form.Control
                    type="text"
                    placeholder="What are you looking for?"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </Form.Group>
              </Col>

              {/* Category Dropdown */}
              <Col md={3} className="search-field">
                <Form.Group controlId="category">
                  <Form.Select
                    value={category}
                    className="custom-category-select"
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option value="" disabled>
                      Category
                    </option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Location Dropdown */}
              <Col md={3} className="search-field">
                <Form.Group controlId="location">
                  <Form.Select
                    value={location}
                    className="custom-category-select"
                    onChange={(e) => setLocation(e.target.value)}
                  >
                    <option value="" disabled>
                      Location
                    </option>
                    {locations.map((loc, index) => (
                      <option key={index} value={loc}>
                        {loc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Button */}
              <Col md={2} className="search-field">
                <button type="submit" className="search-btn">
                  {/* 🔍 */}
                   Search
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>
      <Container className="sixtyPlus">
        <Row>
          <Col sm={6}>
            <div className="trusted-container">
              <div className="trusted-left">
                <h2><span style={{ color: '#f7b12e' }}>60+</span> Plot Ventures<br /><p style={{ color: '#000' }}>Verified By Our Legal Team.</p></h2>
              </div>
            </div>
          </Col>
          <Col sm={6}>
            <div className="trusted-container">
              <div className="trusted-left" >
                <p className='landInvest'>Land investment protection platform led by legal consultants and former Mandal Revenue Officers. We ensure every plot listed with us undergoes rigorous due diligence, saving investors from fraudulent or disputed properties. With one year of free post-verification legal support, we give you peace of mind—before and after your investment.</p>
              </div>

            </div>
            <div className="header-btn d-none d-lg-block mt-4">
              <Link to="/contact" className="tp-btn contactBtn" style={{ borderRadius: '10px' }}>
                Request a Visit
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="trusted-logos mt-5">
            <img src={AG} alt="Hitech" />
            <img src={AS} alt="Hitech" />
            <img src={BG} alt="Hitech" />
            <img src={MID} alt="Hitech" />
            <img src={SI} alt="Hitech" />
            <img src={TMR} alt="Hitech" />

          </div>

        </Row>
      </Container>

      {/* Key Benifit section */}
      <Container className="key-benefits-section">
        <Row>
          <div>
            <h2 className="minimal-heading">
              <span className="bold-part">KEY</span> BENEFITS
            </h2>

          </div>
        </Row>
        <Row className="justify-content-center">
          {benefits.map((benefit, index) => (
            <Col key={index} xs={12} md={6} lg={4} className="mb-4">
              <div className="benefit-card">
                <div className="benefit-icon">
                  {benefit.icon}
                  {/* <span className="benefit-badge">2x</span> */}
                </div>
                <h4 className="benefit-title">{benefit.title}</h4>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Area listings */}
      <AreaListings />

      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h6 className="section-subtitle1 mt-2">CLIENT TESTIMONIALS</h6>
            <h2 className="section-title1">What Our Clients Say</h2>
            <div className="divider"></div>
          </div>

          <div className="horizontal-carousel-container">
            <button
              className="nav-arrow prev-arrow"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <FaChevronLeft />
            </button>

            <Slider ref={sliderRef} {...settings} className="horizontal-testimonial-carousel">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item">
                  <div className="testimonial-card">
                    <FaQuoteLeft className="quote-icon" />
                    <p className="testimonial-text">{testimonial.quote}</p>
                    <div className="testimonial-rating">
                      {[...Array(5)].map((_, i) => (
                        <FaStar
                          key={i}
                          className={i < testimonial.rating ? "star-filled" : "star-empty"}
                        />
                      ))}
                    </div>
                    <div className="testimonial-author">
                      <img
                        src={`${testimonial.image}`}
                        alt={testimonial.author}
                        className="author-image"
                        style={{ width: '40px' }}
                      />
                      <div className="author-info">
                        <h4>{testimonial.author}</h4>
                        <p>{testimonial.position}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <button
              className="nav-arrow next-arrow"
              onClick={() => sliderRef.current.slickNext()}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      </section>

      {/* contact form */}

      <section className="contact-section">
        <div className="contact-container">
          {/* Left Side */}
          <div className="contact-text">
            <h1>We help you buy or sell your property quickly</h1>
            <p>
              Engage with our professional real estate agents to sell, buy, or rent
              your home. Get emails directly to your inbox and manage the lead as
              you wish.
            </p>
          </div>

          {/* Right Side */}
          <div className="contact-form">
            <h2>Get in touch</h2>
            <p>
              Fill out this form and one of our agents will be in touch with you soon.
            </p>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <input type="tel" placeholder="Your Phone" required />
              <textarea placeholder="Type your message..." rows="4" required></textarea>



              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </section>






    </>
  );
};




 
export default Home;